import dayjs from "dayjs";
import { DatePicker, Space, } from "antd";
import { CDateRangePicker } from "@coreui/react-pro";
import { useState, useEffect } from "react";
import "dayjs/locale/th";

import i18next from "i18next";
import localeTH from "antd/es/date-picker/locale/th_TH";
import localeEN from "antd/es/date-picker/locale/en_US";
import { CalendarOutlined, FilterOutlined } from "@ant-design/icons";

export const DateRangePickerDaysExample = ({
  onChangeDate,
  startDate,
  endDate,
}) => {
  const [dates, setDates] = useState({
    startDate: null,
    endDate: null,
  });

  const onDateChange = (type, date) => {
    const newDates = { ...dates, [type]: date };
    setDates(newDates);

    if (newDates.startDate && newDates.endDate) {
      const selectedDates = {
        startDate: dayjs(newDates.startDate).format("YYYY-MM-DD"),
        endDate: dayjs(newDates.endDate).format("YYYY-MM-DD"),
      };
      if (onChangeDate) {
        onChangeDate(selectedDates);
      }
    }
  };
  let start = startDate ? dayjs(startDate).format("YYYY-MM-DD") : "startDate";
  let end = endDate ? dayjs(endDate).format("YYYY-MM-DD") : "endDate";

  return (
    <CDateRangePicker
      className="sm-200"
      locale="th-TH"
      size="sm"
      placeholder={[start, end]}

      onStartDateChange={(date) => onDateChange("startDate", date)}
      onEndDateChange={(date) => onDateChange("endDate", date)}
      dayjsFormat="YYYY-MM-DD"
      todayButton={true}
    />
  );
};

const RangePickerApp = ({ onChangeDate, startDate, endDate, isMobile, t, resProfileAdmin }) => {
  const dateFormat = "YYYY-MM-DD";

  // 1. กำหนด State
  const [dates, setDates] = useState({
    start: startDate ? dayjs(startDate) : null,
  });

  // 2. อัปเดต State เมื่อ Props เปลี่ยน (เช่น กด Reset หรือเปลี่ยนจากภายนอก)
  useEffect(() => {
    setDates({
      start: startDate ? dayjs(startDate) : null,
    });
  }, [startDate, endDate]);

  // 3. จัดการเรื่องภาษา
  const getAntdLocale = () => {
    const currentLanguage = i18next.language;
    if (currentLanguage === "th" || currentLanguage === "lao") return localeTH;
    return localeEN;
  };

  const currentLanguage = i18next.language;
  dayjs.locale(currentLanguage === "lao" ? "lo" : currentLanguage);
  const antdLocale = getAntdLocale();

  // 4. ฟังก์ชันจัดการเมื่อมีการเปลี่ยนวันที่

  const handlePickerChange = (date, type) => {
    const newDates = { ...dates, [type]: date };
    setDates(newDates);

    if (newDates.start) {
      if (onChangeDate) {
        // ใช้ .date(5) เพื่อเจาะจงว่าเป็นวันที่ 5 ของเดือนที่เลือก
        const formattedDate = newDates.start.date(1).format(dateFormat);

        onChangeDate({
          startDate: formattedDate,
        });
      }
    }
  };

  return (
    <Space
      direction="horizontal"
      size={isMobile ? 4 : 8}
      className="range-picker-container mb-3 mt-3 mr-3"
    >
      <div>


        <DatePicker
          picker="month"
          locale={antdLocale}
          value={dayjs(dates.start)}
          format="MMM YYYY"
          onChange={(date) => handlePickerChange(date, "start")}
          disabledDate={(current) => {
            // ห้ามเลือกเดือนปัจจุบัน และห้ามเลือกเดือนในอนาคต
            // .startOf('month') จะทำให้ทุกวันในเดือนปัจจุบันถูก disabled
            if (["programer"].includes(resProfileAdmin?.admin_type)) {
              return false; // Admin สามารถเลือกได้ทุกเดือน
            }
            return current && current >= dayjs().startOf("month");
          }}
          allowClear={false}
          suffixIcon={<FilterOutlined />}
          prefix={<CalendarOutlined />}
        />
      </div>
    </Space>
  );
};

export default RangePickerApp;
